const environment = {
  ENV: process.env.REACT_APP_ENV,
  DOMAIN_URL: process.env.REACT_APP_DOMAIN_URL,
  VIRTUAL_INSTALLATION_CGM_URL: process.env.REACT_APP_VIRTUAL_INSTALLATION_CGM_URL,
  HEALTH_ASSISTANT_DOMAIN_URL:
    process.env.REACT_APP_HEALTH_ASSISTANT_DOMAIN_URL,
  CHAT_URL: process.env.REACT_APP_CHAT_URL,
  API_KEY: process.env.REACT_APP_API_KEY,
  API_BASE_URL: process.env.REACT_APP_API_ENDPOINT,
  API_ENC_KEY: process.env.REACT_APP_ENCRYPTION_KEY,
  API_ENV_IV: process.env.REACT_APP_ENCRYPTION_IV,
  AZURE_CONTAINER_ACCOUNT: process.env.REACT_APP_AZURE_CONTAINER_ACCOUNT,
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  MOENGAGE_APP_ID: process.env.REACT_APP_MOENGAGE_APP_ID,
  MOENGAGE_DATA_CENTER: process.env.REACT_APP_MOENGAGE_DATA_CENTER,
  MOENGAGE_ENABLE_DEBUG_LOGS: process.env.REACT_APP_MOENGAGE_ENABLE_DEBUG_LOGS,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
};

export default environment;
